// Actions is a contant that is being used to identify any user triggers

// ACTIONS
export const ADD_TASK = 'ADD_TASK';
export const REMOVE_TASK = 'REMOVE_TASK';

//CONTENTFUL API
export const FETCH_PAGES = 'FETCH_PAGES';
export const FETCH_PAGES_FAIL = 'FETCH_PAGES_FAIL';



// WEBPACK FOOTER //
// ./client/actions/actions.js